export default [

    { path: '/preview/:offer', name: 'Preview', component: () => import('@/pages/Preview.vue')},

    { path: '*', name: 'Engage', component: () => import('@/pages/PageHandler.vue')},

]



// WEBPACK FOOTER //
// ./src/router/routes.js